export const GET_RECENT_PAYMENTS_REQUEST = "GET_RECENT_PAYMENTS_REQUEST";
export const GET_RECENT_PAYMENTS_SUCCESS = "GET_RECENT_PAYMENTS_SUCCESS";
export const GET_RECENT_PAYMENTS_FAILURE = "GET_RECENT_PAYMENTS_FAILURE";

export const GET_UPCOMING_PAYMENT_REQUEST = "GET_UPCOMING_PAYMENT_REQUEST";
export const GET_UPCOMING_PAYMENT_SUCCESS = "GET_UPCOMING_PAYMENT_SUCCESS";
export const GET_UPCOMING_PAYMENT_FAILURE = "GET_UPCOMING_PAYMENT_FAILURE";